import React, { ReactElement, useContext } from 'react';
import TabHeader from '../../../../components/Tabs/TabHeader';
import {
  FilterOutlined,
  InfoOutlined
} from '@ant-design/icons';
import { Select, Typography } from 'antd';
import Tabs from '../../../../components/Tabs/Tabs';
import TabPane from '../../../../components/Tabs/TabPane';
import HelpTab from './HelpTab';
import FiltersTab from '../../../../components/Tabs/FiltersTab';
import ToolsTab, { ToolsTabIcon } from '../../../../components/Tabs/ToolsTab';
import { INaturalForestWithClashData, NaturalForestsContext } from '../../NaturalForestsContextContainer';
import NaturalForestOption from './NaturalForestOption';
import { Trans, useTranslation } from 'react-i18next';
import ShareTab, { ShareTabIcon } from '../../../../components/Tabs/ShareTab';
const { Option } = Select;

const sortingFn = (item1: INaturalForestWithClashData, item2: INaturalForestWithClashData) => {
  return item1.properties.name.localeCompare(item2.properties.name);
};

const filterOptionFn = (input: any, option: any) => {
  return option && option.value.toLowerCase().includes(input.toLowerCase());
}

export default function NaturalForestsSidePanel() {
  const tabHeaders: ReactElement[] = [
    <TabHeader step={0} key={0}><InfoOutlined /></TabHeader>,
    <TabHeader step={1} key={1}><FilterOutlined /></TabHeader>,
    <TabHeader step={2} key={2}><ToolsTabIcon /></TabHeader>,
    <TabHeader step={3} key={3}><ShareTabIcon /></TabHeader>
  ];
  const naturalForestsContext = useContext(NaturalForestsContext);

  const onNaturalForestSelected = (name: string) => {
    naturalForestsContext.onNaturalForestSelected(name);
  };

  const monthsSince2019Jan = (new Date().getFullYear() - 2019) * 12 + new Date().getMonth();

  const { t } = useTranslation('naturalForests', { useSuspense: true });

  return (
    <>
      <Typography.Title level={3}>{t("otsikko")}</Typography.Title>

      <p>
        <Trans i18nKey="naturalForests:kuvaus1">
          Luonnonmetsätyöryhmä on vuodesta 2019 lähtien kartoittanut Suomesta noin 1400 suojelun arvoista luonnonmetsää, joista 201 he ovat julkaisseet <a href='https://metsat.greenpeace.fi/pages/201_metsaa' target='_blank'>raporteissaan</a>. Tällä kartalla näkyvät kyseiset 201 metsää. Lisäksi kartalla näkyvät metsänkäyttöilmoitukset, jotka on tehty 1.1.2019 jälkeen. Mukana on siis myös jo vanhentuneita ilmoituksia. Näin siitä syystä, että kartalla halutaan näyttää, millä tavalla hakkuut joko tällä hetkellä (voimassaolevat metsänkäyttöilmoitukset) tai jo aiemmin (vanhat ilmoitukset) uhkaavat tai ovat uhanneet - tai itse asiassa jopa tuhonneet - näitä luonnonmetsiä.
        </Trans>
      </p>
      <p>
        <Trans i18nKey="naturalForests:kuvaus2" components={{
          b: <b />, FilterOutlined: <FilterOutlined />
        }}>
          Korkealta katsottuna luonnonmetsät on merkitty palluroilla, jotka ovat joko vihreitä (ei metsänkäyttöilmoituksia alueella 1.1.2019 eteenpäin), punaisia (metsänkäyttöilmoituksia alueella)
          tai mustia (alue hakattu). <b>HUOM!</b> Suodattimista (valikossa <FilterOutlined />) voit säätää, minkä kuukauden jälkeen tulleita metsänkäyttöilmoituksia haluat kartalla näkyvän. Tämä vaikuttaa samalla myös siihen, näkyykö metsä vihreänä vai punaisena.
        </Trans>
      </p>
      <p>
        <Trans i18nKey="naturalForests:kuvaus3">
          Lähempää katsottuna näkee luonnonmetsän tarkan alueen. Kartalla näkyvät myös aukot harmaalla värillä.
          Monissa luonnonmetsissä ei välttämättä ole enää metsänkäyttöilmoituksia voimassa, mutta jos kartalla näkyy metsän kohdalla aukkoja, on metsä siltä kohdin tietysti jo hakattu.
        </Trans>
      </p>

      {naturalForestsContext.naturalForestsWithClashData &&
        <>
          {(naturalForestsContext.totalNaturalForestsSizeHa !== undefined && naturalForestsContext.naturalForestsSizeUnderThreatHa !== undefined) &&
            <p>
              <Trans i18nKey="naturalForests:tilanne"
                components={{ span: <span /> }}
                values={{
                  totalNaturalForestsSizeHa: naturalForestsContext.totalNaturalForestsSizeHa,
                  naturalForestsSizeUnderThreatHa: naturalForestsContext.naturalForestsSizeUnderThreatHa,
                  percentage: ((naturalForestsContext.naturalForestsSizeUnderThreatHa / naturalForestsContext.totalNaturalForestsSizeHa) * 100).toFixed(1).replace(".", ",")
                }}>
                {/* Do not include the text here, it is pretty long */}
              </Trans>
            </p>}

          <p>{t("voitValitaMetsän")}</p>
          <Select
            placeholder={t("valitseMetsä")}
            allowClear
            style={{ "width": "100%", "marginBottom": "1em" }}
            showSearch
            onSelect={onNaturalForestSelected}
            filterOption={filterOptionFn}
            onFocus={() => window.blur()}
          >
            {
              naturalForestsContext.naturalForestsWithClashData.features.sort(sortingFn).map((naturalForest: INaturalForestWithClashData) =>
                <Option value={naturalForest.properties.name} key={naturalForest.properties.name}>
                  <NaturalForestOption key={naturalForest.properties.name} naturalForest={naturalForest} />
                </Option>
              )
            }
          </Select>
        </>}

      <Tabs tabHeaders={tabHeaders}>
        <TabPane number={0}>
          <HelpTab />
        </TabPane>
        <TabPane number={1}>
          <FiltersTab isAgeFilterEnabled={true} isArrivalMonthFilterEnabled={true} getDeclarationsSinceMonths={monthsSince2019Jan} singleSidedDeclarationSlider={true} />
        </TabPane>
        <ToolsTab showFindForestMask={false} number={2} />
        <ShareTab number={3} />
      </Tabs>
    </>
  )
}